<template>
  <v-col cols="12">
    <v-col cols="12">
      <v-row>
        <v-expand-transition>
          <div v-if="!buscandoPorPeriodos" class="col-12 d-flex align-center justify-center">
            <VueCtkDateTimePicker v-model="filtros.desde" label="Desde" format="YYYY-MM-DD HH:mm"
              formatted="YYYY-MM-DD HH:mm" noHeader overlay buttonNowTranslation="Ahora"
              :disabled="loadingOEE || loadingGlobalOEE || loadingFTQ" />

            <VueCtkDateTimePicker v-model="filtros.hasta" label="Hasta" format="YYYY-MM-DD HH:mm"
              formatted="YYYY-MM-DD HH:mm" noHeader overlay buttonNowTranslation="Ahora" class="mx-2"
              :disabled="loadingOEE || loadingGlobalOEE || loadingFTQ" />

            <v-autocomplete v-model="filtros.maquinas" :items="instancias" :item-text="nombreMaquina"
              item-value="idMaquinaIns" label="Máquina (opcional)" clearable multiple chips dense class="mr-2"
              style="min-width: 400px;" :loading="loadingInstancias || loadingOEE"
              :disabled="loadingInstancias || loadingOEE || loadingGlobalOEE || loadingFTQ" />

            <v-btn color="primary" :disabled="!validForm"
              :loading="loadingOEE || loadingGlobalOEE || loadingFTQ || loadingTurnos"
              @click="printSegmentsEverySecond()">
              Buscar
            </v-btn>
            <!-- SNACKBAR LOCAL DEL REPORTE NYX -->
            <v-snackbar
              v-model="snackbarNyx"
              :color="snackbarColorNyx"
              :timeout="4000"
              top
              right
            >
              {{ snackbarTextNyx }}
            </v-snackbar>
          </div>
        </v-expand-transition>
      </v-row>
      <v-row>
        <download-btn
          :disabled="!validForm"
          :loading="loadingExportNyx"
          className="my-4"
          color="blue darken-1"
          text
          @click="abrirDialogTipoReporte"
          label="Descargar Reporte de OEE"
        />
      </v-row>

      <v-dialog v-model="dialogTipoReporte" max-width="560">
        <v-card>
          <v-card-title class="text-h6">
            Selecciona el tipo de reporte
          </v-card-title>
          <v-card-text>
            Puedes generar el reporte clásico o el nuevo detallado con gráficas.
          </v-card-text>
          <v-card-actions class="px-4 pb-4">
            <v-btn
              color="blue darken-1"
              text
              :disabled="loadingExportNyx"
              @click="generarReporteClasico"
            >
              Reporte completo
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              :loading="loadingExportNyx"
              :disabled="loadingExportNyx"
              @click="generarReporteDetallado"
            >
              Reporte con gráficas - Operaciones
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    <v-card>
      <v-card v-if="Object.entries(dataResultGroup).some(() => true) || resGlobalOEETM != null" flat>
        <v-col cols="12">
          <v-col>
            <v-card-subtitle class="d-flex justify-center text-subtitle-2 align-center text--secondary">
              La información mostrada abarca el periodo
              <span class="text-subtitle-2 text--primary mx-2">{{ filtros.desde }}</span>
              hasta
              <span class="text-subtitle-2 text--primary mx-2">{{ hastaFinal }}</span>
            </v-card-subtitle>
          </v-col>
          <v-row class="mt-5">
            <v-col cols="4">
              <center>
                <Velocimetro v-if="!loadingGlobalOEE" v-model="resGlobalOEETM.oeePromedio" ref="oeeNYX"
                  :dataText="`OEE PROMEDIO`" suffix="%" :showText="true" size-px="370" />
                <v-progress-circular v-else indeterminate color="primary" size="370" :width="15" />
              </center>
            </v-col>
            <v-col cols="4">
              <center>
                <Velocimetro v-if="!loadingGlobalOEE" v-model="tmSum" :percent="resGlobalOEETM.tmPromeido" ref="tmNYX"
                  :dataText="`TIEMPO MUERTO ACUMULADO`" :showText="true" size-px="370" />
                <v-progress-circular v-else indeterminate color="primary" size="370" :width="15" />
              </center>
            </v-col>
            <v-col cols="4">
              <center>
                <Velocimetro v-if="!loadingFTQ" v-model="resGlobalFTQ.ftqPromedio" ref="ftqNYX" dataText="FTQ PROMEDIO"
                  suffix="%" :showText="true" size-px="370" />
                <v-progress-circular v-else indeterminate color="primary" size="370" :width="15" />
              </center>
            </v-col>
            <v-col cols="12" class="mt-5" v-if="resGlobalOEETM.detalles != null" flat>
              <v-card flat>
                <v-card-title class="d-flex justify-center align-center">
                  {{ maquinasGrafica.length }}
                  {{ filtros.menorAMayor ? 'Máquinas con OEE crítico' : 'Mejores Máquinas' }}
                </v-card-title>
                <apexchart type="bar" height="350" :options="chartOptionsPeoresMaquinas"
                  :series="seriesPeoresMaquinas" />
                <br>
                <v-data-table :headers="headers" :items="maquinasResumen" class="elevation-1" flat>
                  <template v-slot:top>
                    <v-card-title class="text-h6 d-flex justify-center align-center"
                      style="text-align: center; width: 100%;">
                      Resumen de Máquinas
                    </v-card-title>
                  </template>

                  <template v-slot:item.oee="{ item }">
                    {{ item.oee.toFixed(2) }}%
                  </template>

                  <template v-slot:item.porcentajeTiempoMuerto="{ item }">
                    {{ item.porcentajeTiempoMuerto.toFixed(2) }}%
                  </template>

                  <!-- <template v-slot:item.inicio="{ item }">
                    {{ new Date(item.inicio).toLocaleString() }}
                  </template>

                  <template v-slot:item.fin="{ item }">
                    {{ new Date(item.fin).toLocaleString() }}
                  </template> -->

                  <template v-slot:item.piezasTeoricas="{ item }">
                    {{ item.piezasTeoricas.toLocaleString('en-US', { maximumFractionDigits: 0 }) }}
                  </template>

                  <template v-slot:item.piezasReales="{ item }">
                    {{ item.piezasReales.toLocaleString('en-US', { maximumFractionDigits: 0 }) }}

                  </template>

                  <template v-slot:item.ftq="{ item }">
                    <span v-if="item.ftq !== null">{{ item.ftq.toFixed(2) }}%</span>
                    <span v-else>--</span>
                  </template>

                  <template v-slot:item.segundosAnalizados="{ item }">
                    {{ segundosAFormato(item.segundosAnalizados) }}
                  </template>

                  <template v-slot:item.segundosProductivos="{ item }">
                    {{ segundosAFormato(item.segundosProductivos) }}

                  </template>

                  <template v-slot:item.segundosMuertos="{ item }">
                    {{ segundosAFormato(item.segundosMuertos) }}
                  </template>

                  <!-- segundosParosProgAgenda -->
                  <template v-slot:item.segundosParosProgAgenda="{ item }">
                    <span v-if="item.segundosParosProgAgenda != null">
                      {{ segundosAFormato(item.segundosParosProgAgenda) }}
                    </span>
                    <span v-else>--</span>
                  </template>

                  <!-- segundosParosProgReales -->
                  <template v-slot:item.segundosParosProgReales="{ item }">
                    <span v-if="item.segundosParosProgReales != null">
                      {{ segundosAFormato(item.segundosParosProgReales) }}
                    </span>
                    <span v-else>--</span>
                  </template>
                </v-data-table>
                <br>
                <!-- <v-sheet elevation="1" style="overflow-x: auto;"> -->
                <v-simple-table dense fixed-header class="mt-4" height="auto">
                  <thead>
                    <tr>
                      <th rowspan="3" class="text-left sticky-nombre text-subtitle-2 font-weight-bold">Nombre de la
                        máquina</th>
                      <th rowspan="3" class="text-left sticky-lado text-subtitle-2 font-weight-bold">Lado</th>
                      <th v-for="col in columnasDiasResumen" :key="'col-' + col.key" class="text-center" colspan="2"
                        style="line-height: 1; font-size: 12px;">
                        <span class="text-subtitle-2 font-weight-bold">{{ col.inicio.replace('T', ' ')
                        }}</span><br /><span class="text-subtitle-2 font-weight-bold">{{ col.fin.replace('T', ' ')
                          }}</span>
                      </th>
                    </tr>
                    <tr>
                      <th v-for="col in columnasDiasResumen" :key="'stats-' + col.key" colspan="2" class="text-center">
                        OEE: {{ calcularPromedio(col.key, 'oee') }}%
                        <br>
                        TM: {{ calcularPromedio(col.key, 'porcentajeTiempoMuerto') }}%
                      </th>
                    </tr>
                    <tr>
                      <template v-for="col in columnasDiasResumen">
                        <th :key="'sub-' + col.key + '-teo'" class="text-center">Teóricas</th>
                        <th :key="'sub-' + col.key + '-real'" class="text-center">Reales</th>
                      </template>
                    </tr>
                  </thead>

                  <tbody>
                    <template v-for="(cavidades, nombre) in maquinasConCavidades">
                      <tr v-for="(diasPorCavidad, cavidadNombre, idx) in cavidades" :key="nombre + '-' + cavidadNombre">
                        <td v-if="idx === 0" :rowspan="Object.keys(cavidades).length"
                          class="text-left font-weight-bold sticky-nombre">
                          {{ nombre }}
                        </td>
                        <td class="text-left font-italic sticky-lado">
                          {{ cavidadNombre }}
                        </td>


                        <template v-for="col in columnasDiasResumen">
                          <td :key="nombre + '-' + cavidadNombre + '-' + col.key + '-teo'" class="text-center"
                            style="min-width: 100px;">
                            <!-- {{
                              diasPorCavidad[col.key] && diasPorCavidad[col.key].piezasTeoricas != null
                                ? diasPorCavidad[col.key].piezasTeoricas
                                : '-'
                            }} -->
                            {{
                              diasPorCavidad[col.key] && diasPorCavidad[col.key].piezasTeoricas != null
                                ? formatoNumero(diasPorCavidad[col.key].piezasTeoricas)
                                : '-'
                            }}
                          </td>
                          <td :key="nombre + '-' + cavidadNombre + '-' + col.key + '-real'" class="text-center"
                            style="min-width: 100px;">
                            <!-- {{
                              diasPorCavidad[col.key] && diasPorCavidad[col.key].piezasReales != null
                                ? diasPorCavidad[col.key].piezasReales
                                : '-'
                            }} -->
                            {{
                              diasPorCavidad[col.key] && diasPorCavidad[col.key].piezasReales != null
                                ? formatoNumero(diasPorCavidad[col.key].piezasReales)
                                : '-'
                            }}
                          </td>
                        </template>
                      </tr>
                    </template>
                  </tbody>
                </v-simple-table>
                <!-- </v-sheet> -->
              </v-card>
            </v-col>
            <v-col cols="12" class="mt-5" flat>
              <v-card v-if="resTurnos != null && resTurnos.detalles" flat>
                <v-card-title class="d-flex justify-center align-center">
                  Datos por turnos
                </v-card-title>
                <br>
                <apexchart type="bar" height="500" :options="chartOptionsTurnos" :series="chartSeriesTurnos" />
                <br>
                <v-data-table :headers="headersTurnos" :items="maquinasFiltradas" class="elevation-1" flat>
                  <template v-slot:top>
                    <v-card flat>
                      <v-col cols="12">
                        <v-row no-gutters align="center">
                          <!-- Filtro de Máquinas -->
                          <v-col cols="6" class="Pr-1">
                            <v-autocomplete v-model="filtroTMaquinas" :items="maquinasUnicas" item-text="nombre"
                              item-value="id" label="Filtrar por Máquina" clearable multiple />
                          </v-col>
                          <!-- Filtro de Turnos -->
                          <v-col cols="6" class="Pl-1">
                            <v-autocomplete v-model="filtroTTurnos" :items="turnosUnicos" item-text="nombre"
                              item-value="id" label="Filtrar por Turno" clearable multiple />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-card>
                  </template>

                  <!-- Nombre de máquina -->
                  <template v-slot:item.nombreMaquina="{ item }">
                    {{ item.nombreMaquina }}
                  </template>

                  <!-- Nombre de turno -->
                  <template v-slot:item.nombreTurno="{ item }">
                    {{ item.nombreTurno }}
                  </template>

                  <!-- Piezas teóricas -->
                  <template v-slot:item.piezasTeoricas="{ item }">
                    <span v-if="item.piezasTeoricas != null">
                      {{ item.piezasTeoricas.toLocaleString('en-US', { maximumFractionDigits: 0 }) }}
                    </span>
                    <span v-else>--</span>
                  </template>

                  <!-- Piezas reales -->
                  <template v-slot:item.piezasReales="{ item }">
                    <span v-if="item.piezasReales != null">
                      {{ item.piezasReales.toLocaleString('en-US', { maximumFractionDigits: 0 }) }}
                    </span>
                    <span v-else>--</span>
                  </template>

                  <!-- OEE -->
                  <template v-slot:item.oee="{ item }">
                    <span v-if="item.oee != null">
                      {{ item.oee.toFixed(2) }}%
                    </span>
                    <span v-else>--</span>
                  </template>

                  <!-- Tiempo muerto -->
                  <template v-slot:item.tiempoMuerto="{ item }">
                    <span v-if="item.tiempoMuerto != null">
                      {{ segundosAFormato(item.tiempoMuerto) }}
                    </span>
                    <span v-else>--</span>
                  </template>
                </v-data-table>
              </v-card>
              <v-card v-else-if="loadingTurnos" flat class="d-flex align-center justify-center"
                style="min-height: 200px;">
                <v-col cols="12" class="d-flex flex-column align-center justify-center text-center">
                  <v-progress-circular :size="70" :width="7" color="purple" indeterminate class="mb-4" />
                  <v-card-text>
                    Buscando datos por turnos
                  </v-card-text>
                </v-col>
              </v-card>
            </v-col>
            <v-col cols="12" class="mt-5" v-if="resGlobalOEETM != null || loadingOEETMDiaADia" flat>
              <v-card v-if="resOEETMDiaADia != null && resOEETMDiaADia.promedioPorDia" flat>
                <v-card-title class="d-flex justify-center align-center">
                  OEE Día a Día
                </v-card-title>
                <v-card-subtitle class="d-flex justify-center align-center error-text">
                  Los datos mostrados reflejan días de {{ horaCorte }} a {{ horaCorte }}
                </v-card-subtitle>
                <br>
                <apexchart type="bar" height="550" :options="oeeOptionsPorDia" :series="oeeSeriesPorDia" />
              </v-card>
              <v-card v-else-if="loadingOEETMDiaADia" flat class="d-flex align-center justify-center"
                style="min-height: 200px;">
                <v-col cols="12" class="d-flex flex-column align-center justify-center text-center">
                  <v-progress-circular :size="70" :width="7" color="purple" indeterminate class="mb-4" />
                  <v-card-text>
                    Buscando datos de OEE Día por Día
                  </v-card-text>
                </v-col>
              </v-card>
            </v-col>
            <v-col cols="12" class="mt-5" v-if="resGlobalOEETM != null || loadingOEETMDiaADia" flat>
              <v-card v-if="resOEETMDiaADia != null && resOEETMDiaADia.promedioPorDia" flat>
                <v-card-title class="d-flex justify-center align-center">
                  Tiempo Muerto Día a Día
                </v-card-title>
                <v-card-subtitle class="d-flex justify-center align-center error-text">
                  Los datos mostrados reflejan días de {{ horaCorte }} a {{ horaCorte }}
                </v-card-subtitle>
                <br>
                <apexchart type="bar" height="550" :options="tmOptionsPorDia" :series="tmSeriesPorDia" />
              </v-card>
              <v-card v-else-if="loadingOEETMDiaADia" flat class="d-flex align-center justify-center"
                style="min-height: 200px;">
                <v-col cols="12" class="d-flex flex-column align-center justify-center text-center">
                  <v-progress-circular :size="70" :width="7" color="purple" indeterminate class="mb-4" />
                  <v-card-text>
                    Buscando datos de Tiempo Muerto Día por Día
                  </v-card-text>
                </v-col>
              </v-card>
            </v-col>
            <v-col cols="12" class="mt-5" v-if="resFTQDiaADia != null || loadingOEETMDiaADia" flat>
              <v-card v-if="resFTQDiaADia != null && resFTQDiaADia.promedioPorDia" flat>
                <v-card-title class="d-flex justify-center align-center">
                  FTQ Día a Día
                </v-card-title>
                <v-card-subtitle class="d-flex justify-center align-center error-text">
                  Los datos mostrados reflejan días de {{ horaCorte }} a {{ horaCorte }}
                </v-card-subtitle>
                <br>
                <apexchart type="bar" height="550" :options="ftqOptionsPorDia" :series="ftqSeriesPorDia" />
              </v-card>
              <v-card v-else-if="loadingOEETMDiaADia" flat class="d-flex align-center justify-center"
                style="min-height: 200px;">
                <v-col cols="12" class="d-flex flex-column align-center justify-center text-center">
                  <v-progress-circular :size="70" :width="7" color="purple" indeterminate class="mb-4" />
                  <v-card-text>
                    Buscando datos de FTQ Día por Día
                  </v-card-text>
                </v-col>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-card>
      <v-card v-else-if="loadingGlobalOEE" flat class="d-flex align-center justify-center" style="min-height: 200px;">
        <v-col cols="12" class="d-flex flex-column align-center justify-center text-center">
          <v-progress-circular :size="70" :width="7" color="purple" indeterminate class="mb-4" />
          <v-card-text>
            Buscando datos
          </v-card-text>
        </v-col>
      </v-card>
      <v-card v-else>
        <v-col class="d-flex flex-column align-center justify-center text-center">
          <v-card-text>
            Realiza una cosulta con parametros validos para obtener la información.
          </v-card-text>
        </v-col>
      </v-card>
    </v-card>
  </v-col>
</template>

<script>
import axios from 'axios';
import Velocimetro from '../../Velocimetro.vue';
import DownloadBtn from '../../DownloadBtn.vue';
export default {
  props: {

  },
  components: {
    Velocimetro,
    DownloadBtn
  },
  data() {
    return {
      instancias: [],
      filtros: {
        desde: null,
        hasta: null,
        maquinas: [],
        menorAMayor: true,
      },
      horaCorte: "07:00",

      data: {},
      groupData: [],
      maxMaquinas: 5,

      timerInterval: null,

      loadingDeteniendo: false,
      loadingInstancias: false,
      loadingOEE: false,
      buscandoPorPeriodos: false,
      percentSearch: 0,
      searchAbort: false,

      desdeSearch: null,
      hastaSearch: null,
      hastaFinal: null,

      headers: [
        { text: "Máquina", value: "nombre", align: "center", },
        // { text: "ID", value: "idMaquinaIns", align: "center", },
        // { text: "Inicio", value: "inicio", align: "center", },
        // { text: "Fin", value: "fin", align: "center", },
        { text: "OEE", value: "oee", align: "center", },
        // { text: "TM (%)", value: "porcentajeTiempoMuerto", align: "center", },
        { text: "Pzas Teóricas", value: "piezasTeoricas", align: "center", },
        { text: "Pzas Reales", value: "piezasReales", align: "center", },
        { text: "FTQ", value: "ftq", align: "center", },
        { text: "Analizado", value: "segundosAnalizados", align: "center", },
        { text: "Productivo", value: "segundosProductivos", align: "center", },
        { text: "Paro Calendarizado", value: "segundosParosProgAgenda", align: "center", },
        { text: "Paro Programado", value: "segundosParosProgReales", align: "center", },
        { text: "Muerto", value: "segundosMuertos", align: "center", },
      ],
      filtroTMaquinas: [],
      filtroTTurnos: [],
      headersTurnos: [
        { text: "Máquina", value: "nombreMaquina", align: "center", },
        { text: "Turno", value: "nombreTurno", align: "center", },
        { text: "Pzas Teóricas", value: "piezasTeoricas", align: "center", },
        { text: "Pzas Reales", value: "piezasReales", align: "center", },
        { text: "OEE", value: "oee", align: "center", },
        { text: "Tiempo Muerto", value: "tiempoMuerto", align: "center", }
      ],

      palette: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0'],

      resGlobalOEETM: null,
      resGlobalFTQ: null,
      resTurnos: null,
      resOEETMDiaADia: null,
      resFTQDiaADia: null,

      loadingGlobalOEE: false,
      loadingFTQ: false,
      loadingTurnos: false,
      loadingOEETMDiaADia: false,
      loadingFTQDiaADia: false,
      loadingExportNyx: false,
      dialogTipoReporte: false,
      snackbarNyx: false,
      snackbarTextNyx: '',
      snackbarColorNyx: 'success',
    }
  },
  methods: {
    abrirDialogTipoReporte () {
      if (this.loadingExportNyx || !this.validForm) return;
      this.dialogTipoReporte = true;
    },
    async generarReporteDetallado () {
      if (this.loadingExportNyx) return;
      try {
        this.dialogTipoReporte = false;
        this.loadingExportNyx = true;
        const hastaEfectivo = this.hastaFinal || this.filtros.hasta;
        const payload = {
          desde: this.filtros.desde,
          hasta: hastaEfectivo,
          idsMaquinas: this.filtros.maquinas || [],
          idsTurnos: this.filtroTTurnos || [],
          idsAreas: []
        };

        await axios.post('/Reportes/ExportResumenNyx?formato=xlsx_detallado_oee', payload);

        this.snackbarTextNyx = 'El reporte se está generando en segundo plano. Te avisaremos en Notificaciones cuando esté listo para descargar.';
        this.snackbarColorNyx = 'success';
        this.snackbarNyx = true;
      } catch (e) {
        console.error('No se pudo encolar el reporte', e);

        this.snackbarTextNyx = 'Ocurrió un error al solicitar el reporte.';
        this.snackbarColorNyx = 'error';
        this.snackbarNyx = true;
      } finally {
        this.loadingExportNyx = false;
      }
    },
    async generarReporteClasico () {
      if (this.loadingExportNyx) return;
      try {
        this.dialogTipoReporte = false;
        this.loadingExportNyx = true;

        const hastaEfectivo = this.hastaFinal || this.filtros.hasta;
        const payload = {
          desde: this.filtros.desde,
          hasta: hastaEfectivo,
          idsMaquinas: this.filtros.maquinas || [],
          idsTurnos: this.filtroTTurnos || [],
          idsAreas: []
        };

        // Flujo clásico existente: encolado por Hangfire sin formato explícito.
        await axios.post('/Reportes/ExportResumenNyx', payload);

        this.snackbarTextNyx = 'El reporte clásico se está generando en segundo plano. Te avisaremos en Notificaciones cuando esté listo para descargar.';
        this.snackbarColorNyx = 'success';
        this.snackbarNyx = true;
      } catch (e) {
        console.error('No se pudo generar el reporte clásico', e);
        this.snackbarTextNyx = 'Ocurrió un error al solicitar el reporte clásico.';
        this.snackbarColorNyx = 'error';
        this.snackbarNyx = true;
      } finally {
        this.loadingExportNyx = false;
      }
    },
    //async exportExcel () {
      // helper para formatear "YYYY-MM-DD HH:mm" → "YYYYMMDD_HHMM"
    //  const toStamp = (s) => {
    //    if (!s) return 'NA';
    //    const d = new Date(String(s).replace(' ', 'T'));
    //    const pad = n => String(n).padStart(2, '0');
    //    return `${d.getFullYear()}${pad(d.getMonth()+1)}${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}`;
    //  };

    //  try {
    //    const hastaEfectivo = this.hastaFinal || this.filtros.hasta;
    //    const payload = {
    //      Desde: this.filtros.desde,
    //      Hasta: hastaEfectivo,
    //      IdsMaquinas: this.filtros.maquinas || [],
    //      IdsTurnos: this.filtroTTurnos || [],
    //      IdsAreas: []
    //    };

    //    const resp = await axios.post('/Reportes/ExportResumenNyx', payload, { responseType: 'blob' });

        // nombre preferido: incluye rango y # de máquinas
    //    const desdeStamp = toStamp(this.filtros.desde);
    //    const hastaStamp = toStamp(hastaEfectivo);
    //    const maqCount   = (this.filtros.maquinas || []).length;
    //    const preferido  = `Resumen_Nyx_${desdeStamp}_a_${hastaStamp}_maq${maqCount || 'all'}.xlsx`;

        // si el server mandó nombre, úsalo como respaldo (o viceversa si prefieres)
    //    const dispo = resp.headers['content-disposition'] || '';
    //    const m = dispo.match(/filename\*?=(?:UTF-8'')?([^;]+)/i);
    //    const delServidor = m ? decodeURIComponent(m[1].replace(/"/g, '')) : null;

    //    const nombre = preferido || delServidor || 'Resumen_Nyx.xlsx';

    //    const blob = new Blob([resp.data], {
    //      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    //    });
    //    const url = URL.createObjectURL(blob);
    //    const a = document.createElement('a');
    //    a.href = url; a.download = nombre; document.body.appendChild(a); a.click(); a.remove();
    //    URL.revokeObjectURL(url);
    //  } catch (e) {
    //    console.error('No se pudo generar el Excel', e);
    //  }
    //},
    nombreMaquina: (maquina) => `[${maquina.nombre}] - ${maquina.marca} ${maquina.modelo}`,

    initialice() {
      this.getInstancias();
    },
    getOEETM(desde, hasta) {
      this.resGlobalOEETM = null;
      this.loadingGlobalOEE = true;

      const desdeQS = encodeURIComponent(desde);
      const hastaQS = encodeURIComponent(hasta);
      const maquinas = this.filtros.maquinas || [];
      const idsQS = maquinas.map(id => `idMaquinas=${encodeURIComponent(id)}`).join('&');

      axios
        .get(`/Reportes/ObtenerResumenOEETMNyx?desde=${desdeQS}&hasta=${hastaQS}` + (idsQS ? `&${idsQS}` : ''))
        .then(response => this.resGlobalOEETM = response.data)
        .catch(error => console.log(error))
        .finally(() => {
          this.loadingGlobalOEE = false;
        });
    },
    getFTQ(desde, hasta) {
      this.resGlobalFTQ = null;
      this.loadingFTQ = true;

      const desdeQS = encodeURIComponent(desde);
      const hastaQS = encodeURIComponent(hasta);
      const maquinas = this.filtros.maquinas || [];
      const idsQS = maquinas.map(id => `idMaquinas=${encodeURIComponent(id)}`).join('&');

      axios
        .get(`/Reportes/ObtenerResumenFTQNyx?desde=${desdeQS}&hasta=${hastaQS}` + (idsQS ? `&${idsQS}` : ''))
        .then(response => this.resGlobalFTQ = response.data)
        .catch(error => console.log(error))
        .finally(() => {
          this.loadingFTQ = false;
        });
    },
    getDatosTurnos(desde, hasta) {
      this.resTurnos = null;
      this.loadingTurnos = true;

      const desdeQS = encodeURIComponent(desde);
      const hastaQS = encodeURIComponent(hasta);
      const maquinas = this.filtros.maquinas || [];
      const idsQS = maquinas.map(id => `idMaquinas=${encodeURIComponent(id)}`).join('&');

      axios
        .get(`/Reportes/ObtenerResumenOEETurnosNyx?desde=${desdeQS}&hasta=${hastaQS}` + (idsQS ? `&${idsQS}` : ''))
        .then(response => this.resTurnos = response.data)
        .catch(error => console.log(error))
        .finally(() => {
          this.loadingTurnos = false;
        });
    },
    getOEETMDiaADia(desde, hasta) {
      this.resOEETMDiaADia = null;
      this.loadingOEETMDiaADia = true;

      const desdeQS = encodeURIComponent(desde);
      const hastaQS = encodeURIComponent(hasta);

      // Obtenemos hora de corte desde los filtros (por ejemplo "07:00")
      const horaCorte = this.horaCorte || '00:00';
      const horaCorteQS = encodeURIComponent(horaCorte);

      // Armamos lista de máquinas si hay
      const maquinas = this.filtros.maquinas || [];
      const idsQS = maquinas
        .map(id => `idMaquinas=${encodeURIComponent(id)}`)
        .join('&');

      // Construimos la URL con horaCorte
      let url = `/Reportes/ObtenerResumenOEETMDiasLogicosNyx?desde=${desdeQS}&hasta=${hastaQS}&horaCorte=${horaCorteQS}`;
      if (idsQS) {
        url += `&${idsQS}`;
      }

      axios.get(url)
        .then(response => {
          this.resOEETMDiaADia = response.data;
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.loadingOEETMDiaADia = false;
        });
    },
    getFTQDiaADia(desde, hasta) {
      this.resFTQDiaADia = null;
      this.loadingFTQDiaADia = true;

      const desdeQS = encodeURIComponent(desde);
      const hastaQS = encodeURIComponent(hasta);

      // Obtenemos hora de corte desde los filtros (por ejemplo "07:00")
      const horaCorte = this.horaCorte || '00:00';
      const horaCorteQS = encodeURIComponent(horaCorte);

      // Armamos lista de máquinas si hay
      const maquinas = this.filtros.maquinas || [];
      const idsQS = maquinas
        .map(id => `idMaquinas=${encodeURIComponent(id)}`)
        .join('&');

      // Construimos la URL con horaCorte
      let url = `/Reportes/ObtenerFTQPorDiaLogicoNyx?desde=${desdeQS}&hasta=${hastaQS}&horaCorte=${horaCorteQS}`;
      if (idsQS) {
        url += `&${idsQS}`;
      }

      axios.get(url)
        .then(response => {
          this.resFTQDiaADia = response.data;
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.loadingFTQDiaADia = false;
        });
    },

    getInstancias() {
      this.loadingInstancias = true;
      axios
        .get("/MaquinaInstancias")
        .then(response => this.instancias = response.data)
        .catch(error => console.log(error))
        .finally(this.loadingInstancias = false)
    },
    async getResultadosPorDia(desdeOriginal, hastaoriginal) {
      this.loadingOEE = true

      try {
        const desde = encodeURIComponent(`${desdeOriginal}`)
        const hasta = encodeURIComponent(`${hastaoriginal}`)
        const menorAMayor = encodeURIComponent(this.filtros.menorAMayor)

        const maquinas = this.filtros.maquinas || []
        const idsQS = maquinas.map(id => `idMaquinaIns=${encodeURIComponent(id)}`).join('&')

        const url = `/Reportes/ResultadosReporteTotalNYX?menorAMayor=${menorAMayor}&desde=${desde}&hasta=${hasta}` + (idsQS ? `&${idsQS}` : '')
        const response = await axios.get(url)
        this.groupData.push(response.data);

      } catch (error) {
        console.error("Error al obtener OEE:", error)
      } finally {
        this.loadingOEE = false
      }
    },


    /**
     * Secciona un rango por días.
     *
     * @param {string} startStr - Fecha de inicio en "YYYY-MM-DD HH:mm"
     * @param {string} endStr   - Fecha de fin    en "YYYY-MM-DD HH:mm"
     * @returns {Array<{start: string, end: string}>}
      */
    sectionByDays(startStr, endStr) {
      const fmt = d => {
        const pad = n => String(n).padStart(2, '0');
        return [
          d.getFullYear(),
          pad(d.getMonth() + 1),
          pad(d.getDate())
        ].join('-') + ' ' + [
          pad(d.getHours()),
          pad(d.getMinutes()),
          pad(d.getSeconds())
        ].join(':');
      };

      // Convertir a Date (asume zona local)
      let current = new Date(startStr.replace(' ', 'T'));
      const endDate = new Date(endStr.replace(' ', 'T'));

      const segments = [];

      while (current <= endDate) {
        // fin de este día a las 23:59:59
        const dayEnd = new Date(
          current.getFullYear(),
          current.getMonth(),
          current.getDate(),
          23, 59, 59
        );
        // el segmento termina cuando antes ocurra: dayEnd o endDate
        const segEnd = dayEnd < endDate ? dayEnd : endDate;
        segments.push({
          start: fmt(current),
          end: fmt(segEnd)
        });

        // avanzar al siguiente día a las 00:00:00
        current = new Date(
          current.getFullYear(),
          current.getMonth(),
          current.getDate() + 1,
          0, 0, 0
        );
      }

      return segments;
    },
    /**
     * Imprime en consola, cada segundo, los segmentos generados por sectionByDays.
     *
     * @param {string} startStr - Fecha de inicio en "YYYY-MM-DD HH:mm"
     * @param {string} endStr   - Fecha de fin    en "YYYY-MM-DD HH:mm"
     */
    async printSegmentsEverySecond() {
      // Estado inicial
      this.hastaFinal = null;
      this.groupData = [];
      this.filtroTMaquinas = [];
      this.filtroTTurnos = [];
      this.loadingOEE = this.buscandoPorPeriodos = true;
      this.percentSearch = 0;
      this.searchAbort = false;

      // Ajustar “hasta” si supera el momento actual
      const { desde, hasta } = this.filtros;
      const pad = n => String(n).padStart(2, '0');
      const now = new Date();
      const hDate = new Date(hasta.replace(' ', 'T'));
      const hastaFinal = hDate > now
        ? `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}`
        : hasta;
      this.hastaFinal = hastaFinal;


      this.getOEETM(desde, hastaFinal);
      this.getFTQ(desde, hastaFinal);
      this.getDatosTurnos(desde, hastaFinal);
      this.getOEETMDiaADia(desde, hastaFinal);
      this.getFTQDiaADia(desde, hastaFinal);

      // Generar segmentos y procesarlos uno a uno
      this.desdeSearch = desde;
      const segments = this.sectionByDays(desde, hastaFinal);
      const total = segments.length;
      for (let i = 0; i < total && !this.searchAbort; i++) {
        const { start, end } = segments[i];
        // await this.getResultadosPorDia(start, end)
        //   .catch(e => console.error(`Error segmento ${i + 1}:`, e));
        this.percentSearch = Math.round(((i + 1) / total) * 100);
        this.hastaSearch = end;
      }

      // Finalizar
      this.finishSearch();
    },

    finishSearch() {
      this.loadingDeteniendo = false;
      this.loadingOEE = false;
      this.buscandoPorPeriodos = false;
      this.percentSearch = 0;
    },

    segundosAFormato(segundos) {
      const totalSegundos = Math.round(segundos);

      const dias = Math.floor(totalSegundos / 86400);
      const horas = Math.floor((totalSegundos % 86400) / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundosRestantes = totalSegundos % 60;

      const formatoHoras = String(horas).padStart(2, '0');
      const formatoMinutos = String(minutos).padStart(2, '0');
      const formatoSegundos = String(segundosRestantes).padStart(2, '0');

      return dias > 0
        ? `${dias}d ${formatoHoras}:${formatoMinutos}:${formatoSegundos}`
        : `${formatoHoras}:${formatoMinutos}:${formatoSegundos}`;
    },
    calcularPromedio(key, campo) {
      const datos = this.resGlobalOEETM?.detallesPorDias || [];
      const filtrados = datos.filter(d => `${d.inicio}__${d.fin}` === key);
      if (filtrados.length === 0) return "0.00";

      const suma = filtrados.reduce((acc, cur) => acc + (cur[campo] ?? 0), 0);
      return (suma / filtrados.length).toFixed(2);
    },
    formatoNumero(valor, decimales = 0) {
      const num = Number(valor);
      if (isNaN(num)) return "-";

      return new Intl.NumberFormat("es-MX", {
        minimumFractionDigits: decimales,
        maximumFractionDigits: decimales
      }).format(num);
    },

    maxCavidades(diasPorMaquina) {
      return Math.max(
        ...Object.values(diasPorMaquina).map(cavs => cavs.length)
      );
    },
  },
  mounted() {
    this.initialice();
  },
  computed: {
    validForm() {
      const f = this.filtros;

      if (!f.desde || !f.hasta) return false;

      const desde = new Date(f.desde);
      const hasta = new Date(f.hasta);

      return hasta > desde;
    },
    maquinasGrafica() {
      const maquinas = (this.resGlobalOEETM?.detalles ?? []);
      const primeras = maquinas.length > this.maxMaquinas ? maquinas.slice(0, this.maxMaquinas) : maquinas;
      return primeras;
    },
    chartOptionsPeoresMaquinas() {
      const maquinas = this.maquinasGrafica;
      return {
        chart: {
          height: 350,
          type: 'bar',
        },
        legend: { show: false },
        plotOptions: {
          bar: {
            distributed: true,
            borderRadius: 10,
            dataLabels: { position: 'top' },
          }
        },
        colors: maquinas.map((_, i) => this.palette[i % this.palette.length]),
        dataLabels: {
          enabled: true,
          formatter: val => val + '%',
          offsetY: -20,
          style: { fontSize: '12px', colors: ['#304758'] }
        },
        xaxis: {
          categories: maquinas.map(m => m.nombre),
          position: 'top',
          axisBorder: { show: false },
          axisTicks: { show: false },
          crosshairs: {
            fill: {
              type: 'gradient',
              gradient: {
                colorFrom: '#D8E3F0',
                colorTo: '#BED1E6',
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              }
            }
          },
          tooltip: { enabled: true }
        },
        yaxis: {
          axisBorder: { show: false },
          axisTicks: { show: false },
          labels: { show: false, formatter: val => val + '%' }
        },
        // title: {
        //   text: `OEE General: ${this.data.oeeGeneral?.toFixed(2)}%`,
        //   floating: true,
        //   offsetY: 330,
        //   align: 'center',
        //   style: { color: '#444' }
        // }
      }
    },
    seriesPeoresMaquinas() {
      const maquinas = this.maquinasGrafica; // usa la computada directamente
      return [{
        name: 'OEE',
        data: maquinas.map(m => m.oee.toFixed(2))
      }];
    },

    maquinasResumen() {
      const ftqMap = (this.resGlobalFTQ?.detalles || []).reduce((acc, item) => {
        acc[item.idMaquinaIns] = item.ftq;
        return acc;
      }, {});

      return (this.resGlobalOEETM?.detalles || []).map(item => ({
        ...item,
        ftq: ftqMap[item.idMaquinaIns] ?? null
      }));
    },
    columnasDiasResumen() {
      const datos = this.resGlobalOEETM?.detallesPorDias || [];
      const keys = new Set();
      datos.forEach(d => {
        const key = `${d.inicio}__${d.fin}`;
        keys.add(key);
      });
      return Array.from(keys).map(k => {
        const [inicio, fin] = k.split('__');
        return { key: k, inicio, fin };
      });
    },

    maquinasConCavidades() {
      const datos = this.resGlobalOEETM?.detallesPorDias || [];
      const map = {};

      for (const item of datos) {
        if (!map[item.nombre]) map[item.nombre] = {};
        const cavidad = item.cavidad;

        if (!map[item.nombre][cavidad]) map[item.nombre][cavidad] = {};
        const keyDia = `${item.inicio}__${item.fin}`;

        map[item.nombre][cavidad][keyDia] = {
          piezasTeoricas: item.piezasTeoricas,
          piezasReales: item.piezasReales
        };
      }

      return map;
    },
    dataResultGroup() {
      const arr = this.groupData || [];
      if (!arr.length) return {};

      const { oee, ftq, tm } = arr.reduce(
        (s, { oeeGeneral = 0, ftqGeneral = 0, tmGeneral = 0 }) => ({
          oee: s.oee + +oeeGeneral,
          ftq: s.ftq + +ftqGeneral,
          tm: s.tm + +tmGeneral
        }),
        { oee: 0, ftq: 0, tm: 0 }
      );

      const avg = v => Math.round((v / arr.length) * 100) / 100;

      // Función para convertir segundos a "HH:mm"
      const formatTiempo = segundos => {
        const total = Math.round(segundos);
        const h = String(Math.floor(total / 3600)).padStart(2, "0");
        const m = String(Math.floor((total % 3600) / 60)).padStart(2, "0");
        return `${h}:${m}`;
      };

      const dataResult = {
        oeeGeneral: Math.round(avg(oee)),
        ftqGeneral: Math.round(avg(ftq)),
        tmGeneral: avg(tm),
        dias: arr.flatMap(item => item.dias || []),
        diasMaquinas: arr.flatMap(item => item.diasMaquinas || []),
        oeeNyxMaquinasVM: arr.flatMap(item => item.oeeNyxMaquinasVM || [])
      };

      return dataResult;
    },

    fqProm() {
      if (!this.resGlobalFTQ) return 0;
      const valores = Object.values(this.resGlobalFTQ);
      const suma = valores.reduce((acc, val) => acc + val, 0);
      const promedio = valores.length ? (suma / valores.length) : 0;
      return Math.round(promedio * 100) / 100;
    },
    tmSum() {
      const totalSegundos = this.resGlobalOEETM?.tmSumado;

      if (typeof totalSegundos !== 'number' || totalSegundos <= 0) return '0s';

      const dias = Math.floor(totalSegundos / 86400);
      const horas = Math.floor((totalSegundos % 86400) / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundos = Math.floor(totalSegundos % 60);

      const partes = [];
      if (dias > 0) partes.push(`${dias}D`);
      if (horas > 0) partes.push(`${horas}H`);
      if (minutos > 0) partes.push(`${minutos}M`);
      // if (segundos > 0 || partes.length === 0) partes.push(`${segundos}s`);

      return partes.join(':');
    },

    // 1) MÁQUINAS ÚNICAS
    maquinasUnicas: function () {
      var detalles = (this.resTurnos && Array.isArray(this.resTurnos.detalles))
        ? this.resTurnos.detalles
        : [];
      var ids = {};
      var salida = [];
      for (var i = 0; i < detalles.length; i++) {
        var item = detalles[i];
        if (!ids[item.idMaquinaIns]) {
          ids[item.idMaquinaIns] = true;
          salida.push({ id: item.idMaquinaIns, nombre: item.nombreMaquina });
        }
      }
      return salida;
    },
    // 2) TURNOS ÚNICOS
    turnosUnicos: function () {
      var detalles = (this.resTurnos && Array.isArray(this.resTurnos.detalles))
        ? this.resTurnos.detalles
        : [];
      var ids = {};
      var salida = [];
      for (var i = 0; i < detalles.length; i++) {
        var item = detalles[i];
        if (!ids[item.idTurno]) {
          ids[item.idTurno] = true;
          salida.push({ id: item.idTurno, nombre: item.nombreTurno });
        }
      }
      return salida;
    },
    // 2) DATOS FILTRADOS
    maquinasFiltradas: function () {
      var detalles = (this.resTurnos && Array.isArray(this.resTurnos.detalles))
        ? this.resTurnos.detalles
        : [];
      var promedios = (this.resTurnos && Array.isArray(this.resTurnos.promedioPorTurno))
        ? this.resTurnos.promedioPorTurno
        : [];

      var sinMaq = this.filtroTMaquinas.length === 0;
      var sinTur = this.filtroTTurnos.length === 0;

      // 1) Sin máquinas ni turnos → promedios por turno
      if (sinMaq && sinTur) {
        var out = [];
        for (var j = 0; j < promedios.length; j++) {
          var p = promedios[j];

          var sumTeo = 0;
          var sumReal = 0;
          for (var k = 0; k < detalles.length; k++) {
            if (detalles[k].idTurno === p.idTurno) {
              sumTeo += detalles[k].piezasTeoricas || 0;
              sumReal += detalles[k].piezasReales || 0;
            }
          }

          out.push({
            fecha: null,
            nombreTurno: p.nombreTurno,
            nombreMaquina: 'Promedio',
            piezasTeoricas: sumTeo,
            piezasReales: sumReal,
            oee: p.oeePromedio,
            tiempoMuerto: p.tiempoMuertoPromedio,
            porcentajeTiempoMuerto: p.porcentajeTiempoMuerto
          });
        }
        return out;
      }

      // 2) Con al menos 1 máquina seleccionada → todos los detalles de esas máquinas
      if (!sinMaq) {
        var resultado = [];
        for (var i = 0; i < detalles.length; i++) {
          var it = detalles[i];
          if (this.filtroTMaquinas.indexOf(it.idMaquinaIns) === -1) { continue; }
          if (!sinTur && this.filtroTTurnos.indexOf(it.idTurno) === -1) { continue; }
          resultado.push({
            fecha: it.fecha.split('T')[0],
            nombreTurno: it.nombreTurno,
            nombreMaquina: it.nombreMaquina,
            piezasTeoricas: it.piezasTeoricas,
            piezasReales: it.piezasReales,
            oee: it.oee,
            tiempoMuerto: it.tiempoMuerto,
            porcentajeTiempoMuerto: it.porcentajeTiempoMuerto
          });
        }
        return resultado;
      }

      // 3) Sin máquinas pero con turnos → filtrado por turno
      var filt = [];
      for (var m = 0; m < detalles.length; m++) {
        var item = detalles[m];
        if (sinMaq && !sinTur && this.filtroTTurnos.indexOf(item.idTurno) === -1) {
          continue;
        }
        filt.push(item);
      }
      return filt;
    },
    // 4) SERIES de datos → TM usa ahora porcentajeTiempoMuerto:
    chartSeriesTurnos: function () {
      var items = Array.isArray(this.maquinasFiltradas) ? this.maquinasFiltradas : [];
      var seriesOEE = [], seriesTM = [];
      for (var i = 0; i < items.length; i++) {
        var o = items[i].oee;
        var p = items[i].porcentajeTiempoMuerto;         // ← nueva fuente
        seriesOEE.push(o != null ? Number(o.toFixed(2)) : 0);
        seriesTM.push(p != null ? Number(p.toFixed(2)) : 0); // ← porcentaje a dos decimales
      }
      return [
        { name: 'OEE', type: 'column', data: seriesOEE },
        { name: 'Tiempo Muerto', type: 'column', data: seriesTM }
      ];
    },
    // 5) OPTIONS → tooltip TM sigue mostrando minutos desde tiempoMuerto:
    chartOptionsTurnos: function () {
      var items = Array.isArray(this.maquinasFiltradas) ? this.maquinasFiltradas : [];
      var cats = [];
      for (var i = 0; i < items.length; i++) {
        // ejemplo: "2025-07-01 – TURNO 1"
        var fecha = items[i].fecha || '';
        fecha = fecha.split('T')[0];
        var turno = items[i].nombreTurno || '';
        cats.push(fecha + ' – ' + turno);
      }
      // …categorías iguales…
      return {
        // …plotOptions, dataLabels igual…
        dataLabels: {
          enabled: true,
          offsetY: -2,    // menos desplazamiento hacia arriba
          style: { fontSize: '12px' },
          formatter: function (val, opts) {
            return val + '%';
          }
        },
        xaxis: {
          categories: cats
        },
        yaxis: [
          { title: { text: 'OEE (%)' } },
          // { opposite: true, title: { text: 'Tiempo Muerto (%)' } }
        ],
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: function (val, opts) {
              var si = opts.seriesIndex;
              var dp = opts.dataPointIndex;
              var item = items[dp];
              if (si === 0) {
                // igual: piezasReales / piezasTeoricas
                var reales = item.piezasReales || 0;
                var teoricas = item.piezasTeoricas || 0;
                return reales + 'Pzas' + ' De ' + Math.round(teoricas) + 'Pzas';
              } else {
                // TM → minutos
                var mins = item.tiempoMuerto != null
                  ? Math.round(item.tiempoMuerto / 60)
                  : 0;
                return mins + ' min';
              }
            },
            title: { formatter: function (seriesName) { return seriesName; } }
          }
        }
      };
    },
    diasPorDia() {
      return (this.resOEETMDiaADia &&
        Array.isArray(this.resOEETMDiaADia.promedioPorDia))
        ? this.resOEETMDiaADia.promedioPorDia
        : [];
    },

    // 2) Serie y opciones para OEE (%)
    oeeOptionsPorDia() {
      const cats = this.diasPorDia.map(d => d.fecha.split('T')[0]);

      // altura dinámica: ~64 px por fila (ajusta a gusto)
      const rowH = 64;
      const height = Math.max(350, cats.length * rowH);

      return {
        chart: { type: 'bar', toolbar: { show: true }, height },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '95%',            // gruesas sin invadir a la de arriba/abajo
            dataLabels: { position: 'top' }
          }
        },
        colors: this.palette[1],
        dataLabels: {
          enabled: true,
          formatter: (val) => `${val}%`,
          offsetX: 12,                  // etiqueta afuera a la derecha
          style: {
            fontSize: '22px',           // grande y legible
            fontWeight: '800',
            colors: ['#000']
          },
          background: {                 // mejora contraste del número
            enabled: true,
            borderRadius: 4,
            padding: 4
          }
        },
        stroke: { show: true, width: 2, colors: ['transparent'] },
        xaxis: {
          categories: cats,
          max: 100,                     // si tus datos son 0–100%
          labels: { style: { fontSize: '16px', fontWeight: '600' } }
        },
        yaxis: [{
          labels: { style: { fontSize: '16px', fontWeight: '600' } }
        }],
        tooltip: {
          y: { formatter: (val) => `${val}%`, title: { formatter: (s) => s } }
        }
      };
    },
    oeeSeriesPorDia() {
      const data = this.diasPorDia.map(d =>
        d.oeePromedio != null ? Number(d.oeePromedio.toFixed(2)) : 0
      );
      return [{ name: 'OEE (%)', type: 'bar', data }];
    },
    
    // 3) Serie y opciones para Tiempo Muerto (hh:mm)
    tmOptionsPorDia() {
      const cats = this.diasPorDia.map(d => d.fecha.split('T')[0]);

      // altura dinámica por fila (ajusta a gusto)
      const rowH = 64;                           // pon 80–96 si quieres más grosor
      const height = Math.max(350, cats.length * rowH);

      // mayor valor (en minutos) + 20% de margen a la derecha
      const mins = this.diasPorDia.map(d => Math.round((d.tiempoMuertoTotal || 0) / 60));
      const maxMin = Math.max(0, ...mins);
      const xmax = maxMin ? Math.ceil(maxMin * 1.2) : 60;

      const toHM = (m) => {
        const h = Math.floor(m / 60);
        const mm = m % 60;
        return `${h}h ${mm}m`;
      };

      return {
        chart: { type: 'bar', toolbar: { show: true }, height },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '95%',                 // gruesas sin invadir otras filas
            dataLabels: { position: 'top' }   // etiqueta al final (afuera)
          }
        },
        colors: this.palette[2],
        dataLabels: {
          enabled: true,
          formatter: (val) => toHM(val),
          offsetX: 12,                        // etiqueta afuera a la derecha
          style: {
            fontSize: '22px',
            fontWeight: '800',
            colors: ['#000']
          },
          background: { enabled: true, borderRadius: 4, padding: 4 }
        },
        stroke: { show: true, width: 2, colors: ['transparent'] },
        xaxis: {
          categories: cats,                   // en horizontal aparecen en el eje Y
          max: xmax,
          labels: { style: { fontSize: '16px', fontWeight: '600' } }
        },
        yaxis: [{
          labels: { style: { fontSize: '16px', fontWeight: '600' } }
        }],
        tooltip: {
          y: {
            formatter: (val) => toHM(val),
            title: { formatter: (s) => s }
          }
        }
      };
    },
    tmSeriesPorDia() {
      const data = this.diasPorDia.map(d => Math.round((d.tiempoMuertoTotal || 0) / 60));
      return [{ name: 'Tiempo Muerto', type: 'bar', data }];
    },
    diasFtq() {
      return (this.resFTQDiaADia &&
        Array.isArray(this.resFTQDiaADia.promedioPorDia))
        ? this.resFTQDiaADia.promedioPorDia
        : [];
    },
    // 2) Serie de FTQ (%)
    ftqSeriesPorDia() {
      const data = this.diasFtq.map(d =>
        d.ftqPromedio != null ? Number(d.ftqPromedio.toFixed(2)) : 0
      );
      // usar 'bar' para respetar el layout horizontal
      return [{ name: 'FTQ (%)', type: 'bar', data }];
    },
    ftqOptionsPorDia() {
      const cats = this.diasFtq.map(d => d.inicio.split('T')[0]);

      // altura dinámica (~64 px por fila). Sube a 80–96 si quieres más grosor
      const rowH = 64;
      const height = Math.max(350, cats.length * rowH);

      return {
        chart: { type: 'bar', toolbar: { show: true }, height },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '95%',              // barras gruesas sin encimarse
            dataLabels: { position: 'top' } // etiqueta al final (afuera)
          }
        },
        colors: this.palette[3],
        dataLabels: {
          enabled: true,
          formatter: (val) => `${val}%`,
          offsetX: 12,                     // a la derecha de la barra
          style: { fontSize: '22px', fontWeight: '800', colors: ['#000'] },
          background: { enabled: true, borderRadius: 4, padding: 4 }
        },
        stroke: { show: true, width: 2, colors: ['transparent'] },
        xaxis: {
          categories: cats,                // en horizontal aparecen en eje Y
          max: 100,                        // FTQ en 0–100%
          labels: { style: { fontSize: '16px', fontWeight: '600' } }
        },
        yaxis: [{
          labels: { style: { fontSize: '16px', fontWeight: '600' } }
        }],
        tooltip: {
          y: { formatter: (val) => `${val}%`, title: { formatter: (s) => s } }
        }
      };
    },
  
  },
}
</script>

<!-- <style>
.sticky-col {
  position: sticky;
  left: 0;
  background-color: white;
  /* Asegura que no quede transparente */
  z-index: 300 !important;
}

.sticky-col-header {
  position: sticky;
  left: 0;
  z-index: 300 !important;
  background-color: #f5f5f5;
  /* color similar al encabezado */
}
</style> -->

<style scoped>
.sticky-nombre {
  position: sticky;
  left: 0;
  background: white;
  z-index: 300 !important;
  width: 160px;
  min-width: 160px;
  max-width: 160px;
}

.sticky-lado {
  position: sticky;
  left: 160px;
  /* ← Este valor depende del ancho de la columna anterior */
  background: white;
  z-index: 300 !important;
  width: 120px;
  min-width: 120px;
  max-width: 120px;
}

thead th {
  position: sticky;
  top: 0;
  z-index: 1 !important;
  background: #f5f5f5;
}
</style>
